/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "adminCCPServices/DispositionService";

export const getDispositions = async () => {
	try {
		const response = await axios.get(`${APIGateways.dispositionEndpoint}?filterEnabled=1`, {
			headers: await getAuthHeader(),
		});

		return response.data.result;
	} catch (error) {
		v2.error(`Error getting dispositions`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_DISPOSITIONS_API_ERROR,
		});
		throw error;
	}
};
